import React from "react";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowLeftOutlinedIcon from "@mui/icons-material/ArrowLeftOutlined";
import axios from "axios";
import { formatDate } from "../../../utils/dateFormat";

const InterestDetail = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { id } = useParams();

  const [ploading, setpLoading] = React.useState(false);
  const [interest, setInterest] = React.useState([]);

  const fetchInterest = async () => {
    setpLoading(true);
    try {
      const response = await axios.get(`${apiUrl}getInterestById/${id}`);
      if (response.status === 200) {
        setInterest(response.data);
        setpLoading(false);
      } else {
        toast.error("Failed to load interest data.");
      }
    } catch (error) {
      toast.error("Error fetching interest data.");
      setpLoading(false);
    } finally {
      setpLoading(false);
    }
  };

  React.useEffect(() => {
    fetchInterest(); // Fetch product data when component mounts
  }, []);
  return (
    <div className="dashboard-content-wrap p-10">
      <ToastContainer />
      <div className="box-card">
        <div className="box-card-title mb-6">
          <h1 className="text-lg font-medium flex items-center">
            <Link to="/admin/dashboard/interests" className="goBack mr-3">
              <ArrowLeftOutlinedIcon sx={{ fontSize: "20px", color: "#fff" }} />
            </Link>
            Interest Detail
          </h1>
        </div>
        <div className="box-card-body">
          {ploading ? (
            <div className="w-full text-center mb-5">
              <p>Loading interest data...</p>
            </div>
          ) : (
            <div className="interest-detail">
              <h1>
                <b>{interest.userId?.name} </b>has showed interest in this
                product.
              </h1>

              <p>
                <b>Reply him at:</b>
                <a href={`${interest.userId?.email}`}>
                  {interest.userId?.email}
                </a>
              </p>

              <p>
                <b>Phone Number:</b>
                <a href={`${interest.userId?.phone}`}>
                  {interest.userId?.phone}
                </a>
              </p>

              <p>
                <b>Comments: </b>
                {interest.comment}
              </p>
              <p>
                <b>Created At: </b>
                {formatDate(interest.createdAt)}
              </p>

              <div className="product-i-info">
                <h3>{interest.productId?.title}</h3>
                <div className="product-i-images">
                  {interest.productId?.images.map((image, index) => (
                    <div key={image} className="pii-img">
                      <img src={image} alt="Product Image" />
                    </div>
                  ))}
                </div>

                <div className="product-i-detail">
                  <h4>Product Details:</h4>
                  <p>Category: {interest.productId?.prdCategory}</p>
                  <p>Industry: {interest.productId?.prdIndustry}</p>
                  <p>Condition: {interest.productId?.prdCondition}</p>
                  <p>Brand: {interest.productId?.prdBrand}</p>
                  <p>Type: {interest.productId?.prdType}</p>
                  <p>Ref Number: {interest.productId?.ref_number}</p>
                  <p>OPR Weight: {interest.productId?.opr_weight}</p>
                  <p>Manufacture: {interest.productId?.manufacture}</p>
                  <p>Working Hours: {interest.productId?.workingHours}</p>
                  <p>Cab Type: {interest.productId?.cabType}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InterestDetail;
